export default __webpack_public_path__ + "fb627b5f292451bfda8f5aa943b9622e.png";